import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import '@/common/scss/index.scss';
import '@/common/scss/variables.scss'
import WebLayout from '@/pages/website/layout';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';

dayjs.locale('zh-cn');

// 初始化灰度
// initABInfo({ buildEnv: env });


const root = createRoot(document.getElementById('root')!);

root.render(
  <ConfigProvider locale={zhCN}>
    <HashRouter>
      <Switch>
        <Route path="/website/*" exact component={WebLayout}></Route>
        <Route path="/" exact component={() => <Redirect to='/website/invest' />}></Route>
      </Switch>
    </HashRouter>
  </ConfigProvider>
);
